// src/components/PublicLayout.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import appConfig from '../config/appConfig';

const PublicLayout = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <Header />
            <main className="flex-1 flex items-center justify-center p-4">
                <Outlet />
            </main>

            {/* Developer & License Strip */}
            <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-t border-gray-700">
                <div className="max-w-7xl mx-auto px-6 py-5">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

                        {/* Left — identity */}
                        <div className="flex items-center gap-3">
                            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-primary-600 to-primary-800 flex items-center justify-center flex-shrink-0 shadow">
                                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div>
                                <p className="text-[10px] text-gray-500 uppercase tracking-widest font-semibold">{t('publicLayout.developedBy')}</p>
                                {appConfig.vendorUrl ? (
                                    <a
                                        href={appConfig.vendorUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-white font-bold text-sm leading-tight hover:text-primary-300 transition-colors"
                                    >
                                        {appConfig.vendorName}
                                    </a>
                                ) : (
                                    <p className="text-white font-bold text-sm leading-tight">{appConfig.vendorName}</p>
                                )}
                                <p className="text-gray-500 text-xs"></p>
                            </div>
                        </div>

                        {/* Centre — contact details */}
                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 text-sm">
                            {appConfig.vendorEmail && (
                                <a
                                    href={`mailto:${appConfig.vendorEmail}`}
                                    className="flex items-center gap-2 text-gray-400 hover:text-primary-400 transition-colors"
                                >
                                    <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    {appConfig.vendorEmail}
                                </a>
                            )}
                            {appConfig.vendorPhone && (
                                <a
                                    href={`tel:${appConfig.vendorPhone.replace(/\s+/g, '')}`}
                                    className="flex items-center gap-2 text-gray-400 hover:text-primary-400 transition-colors"
                                >
                                    <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.042 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                    </svg>
                                    {appConfig.vendorPhone}
                                </a>
                            )}
                        </div>

                        {/* Right — purchase CTA */}
                        <div className="text-left sm:text-right">
                            <p className="text-xs text-gray-500 mb-1">{t('publicLayout.licenseSupport')}</p>
                            <a
                                href={`mailto:${appConfig.vendorEmail}?subject=License%20Purchase%20%E2%80%94%20${encodeURIComponent(appConfig.vendorName)}`}
                                className="inline-flex items-center gap-1 text-sm font-semibold text-primary-400 hover:text-primary-300 transition-colors"
                            >
                                {t('publicLayout.contactSupport')}
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </a>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default PublicLayout;
